import { Map } from 'immutable';

export const CREATE_SCENARIO = 'CREATE_SCENARIO';
export const CREATE_SCENARIO_SUCCESS = 'CREATE_SCENARIO_SUCCESS';
export const CREATE_SCENARIO_FAIL = 'CREATE_SCENARIO_FAIL';

export const UPDATE_SCENARIO = 'UPDATE_SCENARIO';
export const UPDATE_SCENARIO_SUCCESS = 'UPDATE_SCENARIO_SUCCESS';
export const UPDATE_SCENARIO_FAIL = 'UPDATE_SCENARIO_FAIL';

export const DELETE_SCENARIO = 'DELETE_SCENARIO';
export const DELETE_SCENARIO_SUCCESS = 'DELETE_SCENARIO_SUCCESS';
export const DELETE_SCENARIO_FAIL = 'DELETE_SCENARIO_FAIL';

export const LOAD_SCENARIOS = 'LOAD_SCENARIOS';
export const LOAD_SCENARIOS_SUCCESS = 'LOAD_SCENARIOS_SUCCESS';
export const LOAD_SCENARIOS_FAIL = 'LOAD_SCENARIOS_FAIL';

const initialState = {
  loading: false,

  scenariosMap: Map(),
  error: undefined
};

const startLoading = (state, action) => {
  return { ...state, loading: true, error: undefined };
};

const stopLoading = (state, action) => {
  return { ...state, loading: false, error: action.error };
};

const ScenariosReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CREATE_SCENARIO:
    case UPDATE_SCENARIO:
    case DELETE_SCENARIO:
    case LOAD_SCENARIOS:
      return {
        ...state,
        loading: true,
        error: undefined
      };

    case CREATE_SCENARIO_FAIL:
    case UPDATE_SCENARIO_FAIL:
    case DELETE_SCENARIO_FAIL:
    case LOAD_SCENARIOS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case CREATE_SCENARIO_SUCCESS:
    case UPDATE_SCENARIO_SUCCESS:
      return {
        ...state,
        loading: false,
        scenariosMap: state.scenariosMap.set(action.scenario.id, action.scenario)
      };

    case DELETE_SCENARIO_SUCCESS:
      return {
        ...state,
        loading: false,
        scenariosMap: state.scenariosMap.delete(action.id)
      };

    case LOAD_SCENARIOS_SUCCESS:
      return {
        ...state,
        loading: false,
        scenariosMap: state.scenariosMap.merge(
          action.scenarios.reduce((map, form) => map.set(form.id, form), Map())
        )
      };

    default:
      return state;
  }
};

export default ScenariosReducer;
